import Grid from '@material-ui/core/Grid';
import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FPToggleButton from 'UI/components/molecules/FPToggleButton';

export const InfoText = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(1)
}));

export const LastUpdateText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2)
}));

export const ToggleButtonStyled = styled(FPToggleButton)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  minWidth: 'max-content'
}));

export const ActionsContainer = styled(Grid)(({ theme }) => ({
  alignItems: 'center',
  marginBottom: theme.spacing(2)
}));

export const MatchMakingButtonsContainer = styled(Grid)({
  alignItems: 'center',
  display: 'flex'
});
